import { Helmet } from 'react-helmet-async';
import LegalPage from '../components/LegalPage';
import { PHONE, PHONE_HREF } from '../contact.config';

const sections = [
  {
    heading: 'Our Accessibility Commitment',
    content: [
      'YN Dream Curtains is committed to ensuring our website and services are accessible to all people, including those with disabilities. We believe everyone deserves equal access to information about our products and the ability to book our services.',
      'We strive to conform to the <strong>Web Content Accessibility Guidelines (WCAG) 2.1</strong> at Level AA, published by the World Wide Web Consortium (W3C).',
    ],
  },
  {
    heading: 'Measures We Have Taken',
    content: [
      '• Semantic HTML structure for screen reader compatibility.',
      '• Sufficient colour contrast ratios throughout the site.',
      '• Keyboard-navigable menus and interactive elements.',
      '• Descriptive alt text for all meaningful images.',
      '• Clear, consistent navigation and page structure.',
      '• Responsive design for all screen sizes and devices.',
    ],
  },
  {
    heading: 'Known Limitations',
    content: [
      'While we strive for full accessibility, some areas of our website may not yet fully meet all WCAG 2.1 AA criteria. We are actively working to identify and address these gaps. If you encounter any accessibility barriers, please contact us so we can assist you directly.',
    ],
  },
  {
    heading: 'Alternative Access',
    content: [
      'If you are unable to access any part of our website due to a disability or impairment, please contact us directly and we will be happy to provide information or assistance through an alternative means — including by phone, email, or by arranging an accessible in-home consultation.',
    ],
  },
  {
    heading: 'Feedback & Contact',
    content: [
      `We welcome your feedback on the accessibility of our website. If you experience any accessibility barriers or have suggestions for improvement, please contact us via our <a href="/contact">Contact page</a> or call us on <a href="${PHONE_HREF}">${PHONE}</a>. We aim to respond to accessibility feedback within 3 business days.`,
    ],
  },
];

export default function Accessibility() {
  return (
    <>
      <Helmet>
        <title>Accessibility Statement | YN Dream Curtains Adelaide</title>
        <meta name="description" content="YN Dream Curtains accessibility commitment — ensuring our curtains and blinds website is accessible to all users." />
        <link rel="canonical" href="https://yndreamcurtains.com/accessibility" />
      </Helmet>
      <LegalPage
        title="Accessibility Statement"
        subtitle="Our commitment to making yndreamcurtains.com accessible to everyone."
        lastUpdated="January 2025"
        sections={sections}
        relatedLinks={[
          { label: 'Privacy Policy', to: '/privacy-policy' },
          { label: 'Terms & Conditions', to: '/terms' },
          { label: 'Refund Policy', to: '/refund-policy' },
        ]}
      />
    </>
  );
}
